import client from './client';

export const techniqueCuesApi = {
  resolve: (exerciseId, clientId) =>
    client.get('/technique-cues/resolve', {
      params: { exercise_id: exerciseId, ...(clientId ? { client_id: clientId } : {}) },
    }),
  resolveBatch: (exerciseIds, clientId) =>
    client.get('/technique-cues/resolve-batch', {
      params: {
        exercise_ids: exerciseIds.join(','),
        ...(clientId ? { client_id: clientId } : {}),
      },
    }),
  library: () => client.get('/technique-cues/coach-library'),
  upsert: (payload) => client.post('/technique-cues', payload),
  delete: (id) => client.delete(`/technique-cues/${id}`),
};
